import React from 'react'

function scoreClass(s) {
  if (s >= 80) return 'excellent'
  if (s >= 65) return 'good'
  if (s >= 50) return 'moderate'
  if (s >= 35) return 'marginal'
  return 'poor'
}

function scoreColor(s) {
  if (s >= 80) return 'var(--score-excellent)'
  if (s >= 65) return 'var(--score-good)'
  if (s >= 50) return 'var(--score-moderate)'
  if (s >= 35) return 'var(--score-marginal)'
  return 'var(--score-poor)'
}

export function ScoreBadge({ score }) {
  return (
    <div className={`score-badge ${scoreClass(score)}`}>
      {Math.round(score)}
    </div>
  )
}

const DIMS = [
  { key: 'resource_score',       label: 'Resource' },
  { key: 'infrastructure_score', label: 'Infrastructure' },
  { key: 'risk_score',           label: 'Risk' },
  { key: 'financial_score',      label: 'Financial' },
]

export default function ScoreCard({ scores }) {
  if (!scores) return null
  return (
    <div className="card">
      <div className="card__title">Composite Scores</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 14 }}>
        <ScoreBadge score={scores.overall_score} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>
            {Math.round(scores.overall_score)} / 100
          </div>
          <div style={{ color: scoreColor(scores.overall_score), fontSize: 12, fontWeight: 600 }}>
            {scoreClass(scores.overall_score).charAt(0).toUpperCase() + scoreClass(scores.overall_score).slice(1)}
          </div>
        </div>
      </div>
      <div className="score-grid">
        {DIMS.map(({ key, label }) => {
          const val = scores[key] ?? 0
          return (
            <div key={key} className="score-item">
              <span className="score-item__label">{label}</span>
              <div className="score-item__bar">
                <div
                  className="score-item__fill"
                  style={{ width: `${val}%`, background: scoreColor(val) }}
                />
              </div>
              <span className="score-item__value" style={{ color: scoreColor(val) }}>
                {Math.round(val)}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
